export default __webpack_public_path__ + "static/media/Xarathrustra-minion-particle_0000_Ziv.e867ae7a.png";